import { ControllerBase } from "controllerBase";
import microuniversoApi from "../../api/microuniversoApi";

declare var TransportadoraOrcamentoController: any
declare var EditarItemOrcamentoView: any
declare var window: any


const EditarItensOrcamentoController = ControllerBase.extend({
    name: "EditarItensOrcamentoController",

    ajax: function() {
        return {
            url: "/Orcamento/_EditarItens",
            type: "get",
            cache: false,
            data: { identificadorOrcamento: this.identificadorOrcamento }
        };
    },

    renderizado: function() {
        this.itemIndex = 0;

        this.atacharEventos();

        this.editarItem();

        if (this.collection.length > this.itemIndex + 1) {

            this.botaoAnterior = this.addActionButton({
                    id: "anterior",
                    text: "Anterior",
                    'class': "icone-anterior",
                    click: $.proxy(this.anterior, this),
                    attr: {
                        disabled: this.itemIndex == 0,
                        title: "Tecla atalho [<]",
                        accesskey: "<"
                    }
                },
                true);

            this.botaoProximo = this.addActionButton({
                    id: "proximo",
                    text: "Próximo",
                    'class': "icone-proximo",
                    click: $.proxy(this.proximo, this),
                    attr: {
                        title: "Tecla atalho [>]",
                        accesskey: ">"
                    }
                },
                true);
        }

        $('a[data-toggle="tab"]', this.region.$el).on("shown.bs.tab", $.proxy(this.tabSelecionada, this));
        if(! this.readOnly) $('input[name="Quantidade"]').focus(); //FNX-3141
    },

    tabSelecionada: function(e) {

        var name = $(e.target).attr("aria-controls");

        switch (name) {
        case "tab-dados-tinta":

            if (this.dadosItemTintaController) {
                return;
            }

            this.dadosItemTintaController = this.showView({
                region: {
                    name: "dadosItemTintaRegion",
                    selector: "#tab-dados-tinta"
                },
                controller: {
                    type: TransportadoraOrcamentoController,
                    args: {
                        orcamento: this.orcamento,
                        readOnly: this.readOnly
                    }
                }
            });

            break;

        }

    },

    editarItem: function() {
        this.editarItemOrcamentoView = this.showView({
            region: {
                name: "editarItensOrcamentoViewRegion",
                selector: "#editar-itens-orcamento-region"
            },
            view: {
                type: EditarItemOrcamentoView,
                args: {
                    model: this.collection.at(this.itemIndex),
                    finalizarEdicaoItemCallback: $.proxy(this.finalizarEdicaoItem, this),
                    cancelarEdicaoItemCallback: $.proxy(this.cancelarEdicaoItem, this),
                    readOnly: this.readOnly,
                    itemExcluidoCallback: this.itemExcluidoCallback
                }
            }
        });
    },

    proximo: function () {
        const self = this;
        if (this.itemIndex + 1 == this.collection.length &&
            typeof this.finalizarEdicaoItens != "undefined" &&
            this.finalizarEdicaoItens) {
            this.finalizarEdicaoItens();
            return;
        }

        this.itemIndex++;
        this.editarItem();


        if (this.itemIndex > 0) {
            this.getActionButtonById("anterior").prop("disabled", false);
        }
        if (!this.readOnly) {
            setTimeout(function () {
                if (self.editarItemOrcamentoView) {
                    self.editarItemOrcamentoView.ui.quantidade.focus();
                }
            }, 10);
        }
    },

    anterior: function () {
        const self = this;
        this.itemIndex--;
        this.editarItem();

        if (this.itemIndex == 0) {
            this.getActionButtonById("anterior").prop("disabled", true);
        }

        if (this.itemIndex + 1 == this.collection.length) {
            this.getActionButtonById("proximo").prop("disabled", false);
        }

        if (this.itemIndex > 0) {
            this.getActionButtonById("anterior").prop("disabled", false);
        }

        if (!this.readOnly) {
            setTimeout(function () {
                if (self.editarItemOrcamentoView) {
                    self.editarItemOrcamentoView.ui.quantidade.focus();
                }
            }, 10);
        }
    },
    changeMotivo: async function(value: string) {
        console.log(value)
    },

    atacharEventos: async function() {
        //this.addActionButton({
        //    text: 'Aplicar Tudo',
        //    'class': 'icone-check separador',
        //    click: $.proxy(this.aplicarTudo, this)
        //}, true);
        $("input").on('focus', function () { $(this).select(); });

    },

    finalizarEdicaoItem: function() {

        if (this.itemIndex + 1 == this.collection.length &&
            typeof this.finalizarEdicaoItens != "undefined" &&
            this.finalizarEdicaoItens) {
            this.finalizarEdicaoItens();
            return;
        }

        this.proximo();

    },

    cancelarEdicaoItem: function() {

    },

    dispose: function() {
        if (this.editarItemOrcamentoView) {
            this.editarItemOrcamentoView.dispose();
        }
    }

})

window.EditarItensOrcamentoController = EditarItensOrcamentoController

export {
    EditarItensOrcamentoController
}
